import assets from "./university-assets.json";

const university = (id, name, city, rank, focus) => ({ id, name, city, rank, focus, ...assets[id] });
export const rankingSource = "https://www.topuniversities.com/world-university-rankings/2026";
export const universities = {
  uk: [
    university("imperial", "Imperial College London", "London", 2, "Science, engineering, medicine & business"),
    university("oxford", "University of Oxford", "Oxford", 4, "Humanities, sciences, law & medicine"),
    university("cambridge", "University of Cambridge", "Cambridge", 6, "Sciences, engineering & humanities"),
    university("ucl", "University College London", "London", 9, "Architecture, education, medicine & research"),
    university("kings", "King’s College London", "London", 31, "Health, law & international affairs"),
  ],
  usa: [
    university("mit", "Massachusetts Institute of Technology", "Cambridge, Massachusetts", 1, "Engineering, computing & management"),
    university("stanford", "Stanford University", "Stanford, California", 3, "Technology, research & entrepreneurship"),
    university("harvard", "Harvard University", "Cambridge, Massachusetts", 5, "Medicine, law, business & liberal arts"),
    university("caltech", "California Institute of Technology", "Pasadena, California", 10, "Fundamental sciences & engineering"),
    university("chicago", "University of Chicago", "Chicago, Illinois", 13, "Economics, social sciences & research"),
  ],
  canada: [
    university("mcgill", "McGill University", "Montréal, Québec", 27, "Medicine, life sciences & research"),
    university("toronto", "University of Toronto", "Toronto, Ontario", 29, "Computing, medicine & engineering"),
    university("ubc", "University of British Columbia", "Vancouver & Kelowna", 40, "Environment, sciences & business"),
    university("alberta", "University of Alberta", "Edmonton, Alberta", 94, "Energy, engineering & health sciences"),
    university("waterloo", "University of Waterloo", "Waterloo, Ontario", 119, "Computing, engineering & co-op education"),
  ],
  australia: [
    university("melbourne", "University of Melbourne", "Melbourne, Victoria", 19, "Medicine, law, business & research"),
    university("unsw", "UNSW Sydney", "Sydney, New South Wales", 20, "Engineering, technology & business"),
    university("sydney", "University of Sydney", "Sydney, New South Wales", 25, "Health, humanities & professional study"),
    university("anu", "Australian National University", "Canberra, ACT", 32, "Public policy, sciences & research"),
    university("monash", "Monash University", "Melbourne, Victoria", 36, "Pharmacy, engineering & health sciences"),
  ],
  germany: [
    university("tum", "Technical University of Munich", "Munich", 22, "Engineering, technology & natural sciences"),
    university("lmu", "LMU Munich", "Munich", 58, "Medicine, sciences & humanities"),
    university("heidelberg", "Heidelberg University", "Heidelberg", 80, "Medicine, life sciences & research"),
    university("fu-berlin", "Freie Universität Berlin", "Berlin", 88, "Social sciences, humanities & life sciences"),
    university("kit", "Karlsruhe Institute of Technology", "Karlsruhe", 98, "Engineering, computing & energy"),
  ],
  "new-zealand": [
    university("auckland", "University of Auckland", "Auckland", 65, "Engineering, medicine & business"),
    university("otago", "University of Otago", "Dunedin", 197, "Health sciences, dentistry & research"),
    university("massey", "Massey University", "Palmerston North, Auckland & Wellington", 230, "Agriculture, veterinary science & design"),
    university("wellington", "Victoria University of Wellington", "Wellington", 240, "Law, public policy & humanities"),
    university("canterbury", "University of Canterbury", "Christchurch", 261, "Engineering, education & sciences"),
  ],
};